// extracted by mini-css-extract-plugin
export default {"inviteClientButton":"styles_inviteClientButton__boXbS","closeClientDrawerIcon":"styles_closeClientDrawerIcon__NmW+o"};